import { Redirect } from 'react-router-dom';

import { useGlobalAuthStore } from '@Stores/global/auth';
import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import SystemSettingFormLayout from './containers/SystemSettingForm';
import ThemeFormLayout from './containers/ThemeSelectorForm';
import ThemeSettingFormLayout from './containers/ThemeSettingForm';
import NavigationLayout from './views/navigation/Layout';
import RootfileLayout from './views/rootfile/Layout';
import RouteLayout from './views/route/Layout';

export default function SettingLayout() {
  const { auth: { isSuperAdmin } } = useGlobalAuthStore()
  const defaultRoute = isSuperAdmin ? "themes" : "navigations"
  return <>
    <Router>
      <PrivateRoute path="/cms/settings/themeSettings" component={ThemeSettingFormLayout} />
      <PrivateRoute path="/cms/settings/systemSettings" component={SystemSettingFormLayout} />
      {isSuperAdmin && <PrivateRoute path="/cms/settings/themes" component={ThemeFormLayout} />}
      <PrivateRoute path="/cms/settings/routes" component={RouteLayout} />
      <PrivateRoute path="/cms/settings/navigations" component={NavigationLayout} />
      <PrivateRoute path="/cms/settings/rootfiles" component={RootfileLayout} />
      <Redirect to={`/cms/settings/${defaultRoute}`} />
    </Router>
  </>
}
